import { render } from "./detailHome.vue?vue&type=template&id=b49e8d06&scoped=true"
import script from "./detailHome.vue?vue&type=script&lang=js"
export * from "./detailHome.vue?vue&type=script&lang=js"

import "./detailHome.vue?vue&type=style&index=0&id=b49e8d06&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b49e8d06"]])

export default __exports__